export const AriaWidgetRole = {
  Button: 'button',
  Checkbox: 'checkbox',
  ComboBox: 'combobox',
  Grid: 'grid',
  GridCell: 'gridcell',
  Link: 'link',
  ListBox: 'listbox',
  Menu: 'menu',
  MenuBar: 'menubar',
  MenuItem: 'menuitem',
  MenuItemCheckbox: 'menuitemcheckbox',
  MenuItemRadio: 'menuitemradio',
  Option: 'option',
  ProgressBar: 'progressbar',
  Radio: 'radio',
  RadioGroup: 'radiogroup',
  Scrollbar: 'scrollbar',
  SearchBox: 'searchbox',
  Separator: 'separator',
  Slider: 'slider',
  SpinButton: 'spinbutton',
  Switch: 'switch',
  Tab: 'tab',
  TabList: 'tablist',
  TabPanel: 'tabpanel',
  TextBox: 'textbox',
  Tree: 'tree',
  TreeGrid: 'treegrid',
  TreeItem: 'treeitem',
};
